if not App.angularApp?
    return

App.angularApp.directive 'mfValidate', ['$compile', '$templateCache', ($compile, $templateCache) ->
    require: 'mfValidate'
    controller: ['$scope', '$http', '$q', '$interpolate', ($scope, $http, $q, $interpolate) ->
        # This is the one that gets called when you click the save button
        save: (setAllDirty = true, params = []) ->
            # Get function reference
            saveFn = $scope.$eval @element.attr('mf-validate')

            # Get if we are pretending or not
            pretending = $http.defaults.headers.common['PretendValidate']

            # Add the pretending bool to the params
            params = [pretending?].concat params

            # Call the save function with the params
            promise = saveFn.apply($scope, params)

            if typeof promise?.then isnt 'function'
                return

            return promise.finally (response) ->
                for name, object of $scope.$validation
                    object.$errors = []
                    object.$invalid = false
                return
            .catch (response) ->
                if response.status is 422
                    for name, errors of response.data
                        $scope.$validation[name]?.$errors = errors
                        $scope.$validation[name]?.$invalid = true

                    return $q.resolve()
                return $q.reject(response)
            .finally () =>
                # If you click the save button, it should dirty every input and group
                if setAllDirty
                    object.$dirty = true for name, object of $scope.$validation

                for name, object of $scope.$validation
                    @markElementValidity object

                return
            .catch (error) ->
                throw error if error isnt 'cancel'

        markElementValidity: (validationObject) ->
            input = @element.find("[mf-validate-uid=#{validationObject.$uid}]").find('[mf-validate-repeat],[mf-validate-model]')

            # Special handling for UI Selects
            if input.hasClass 'ui-select-container'
                input = input.find('a')
            else if input.parents('.nav-tabs').length > 0
                input = input.closest('a')

            if validationObject.$invalid
                input.addClass 'mfvalidate-invalid' if validationObject.$dirty
                if not validationObject.$isGroup
                    @markGroupsInvalid input, validationObject
            else
                input.removeClass 'mfvalidate-invalid'

        markGroupsInvalid: (input, validationObject) ->

            # Set group validity
            for groupName in validationObject.$groups
                groupValidationObject = $scope.$validation[groupName]
                continue if not groupValidationObject?

                # Only mark a group invalid if you can't currently see this input
                # and the tab for the group isn't currently active
                matchUid = "[mf-validate-uid='#{groupValidationObject.$uid}']"
                if not input.is(':visible') and not input.parents(".nav-tabs .active #{matchUid}").length
                    groupValidationObject.$invalid = true
                    groupValidationObject.$errors = ['Click here to address errors.']
                    @markElementValidity groupValidationObject

        # This is the one that gets called if you're just typing in an input
        validate: (setAllDirty = false) ->
            $http.defaults.headers.common['PretendValidate'] = true

            promise = @save(setAllDirty)

            delete $http.defaults.headers.common['PretendValidate']

            return promise

        hasDirtyErrors: (filter = undefined) ->
            if filter is undefined
                for name, obj of $scope.$validation
                    if obj.$errors.length > 0 and obj.$dirty
                        return true
                return false

            # If filter isnt undefined
            for name, obj of $scope.$validation
                if (name is filter or obj.$groups.indexOf(filter) >= 0) and obj.$errors.length > 0 and obj.$dirty
                    return true

            return false

        registerInput: (input, name = undefined, ngModel = undefined) ->
            topLevelElement = input.closest '[mf-validate]'
            name = input.attr('name') or name or input.attr('ng-model') or input.attr('mf-validate-model')

            # Get this here because for some frakking reason input.scope()
            # changes when we add the wrapper div around the element. We have
            # to use the input element's scope, not the dialog's scope, in
            # order for the watch to evaluate properly.
            inputScope = input.scope()

            # a ui-select's scope may cause issues, so use the parent instead
            if inputScope.$select?
                inputScope = inputScope.$parent

            # Give the input a unique name
            uid = Math.random().toString(36).substring(2)

            # interpolate variables in the name
            name = $interpolate(name)(inputScope)

            $scope.$validation[name] =
                $dirty: false
                $invalid: false
                $errors: []
                $uid: uid
                $groups: []
                $isGroup: @element.find("[mf-validate-group='#{name}']").length > 0

            # Calculate what groups this input is in
            input.parentsUntil(@element, '[mf-validate-group]').each (_, element) ->
                group = angular.element(element).attr('mf-validate-group')
                # $interpolate allows for doing fancy things like putting
                # mf-validate-group='group<% $index %>' inside an ng-repeat
                $scope.$validation[name].$groups.push $interpolate(group)(inputScope)

            if input.parents('.nav-tabs').length
                inputWithAddons = input
                # the wrapper for nav tabs shouldn't have a width
                wrapper = angular.element("<div style='top: 0; left: 0;'
                    mf-validate-uid='#{uid}'
                ></div>")
            else
                # but for everything else I guess it needs a width?
                inputWithAddons = input.add(input.siblings('.add-on'))
                pixels = _.sumBy(inputWithAddons, (el) -> $(el).outerWidth())

                if pixels is 0
                    wrapper = angular.element("<div
                        style='top: 0; left: 0;'
                        mf-validate-uid='#{uid}'
                    ></div>")
                else
                    wrapper = angular.element("<div
                        style='top: 0; left: 0; width: #{pixels}px'
                        mf-validate-uid='#{uid}'
                    ></div>")

                debounced = debounce () ->
                    els = topLevelElement.find("[mf-validate-uid=#{uid}]")
                        .find('[mf-validate-repeat],[mf-validate-model],.add-on')
                    pixels = _.sumBy(els, (el) -> $(el).outerWidth())
                    if pixels isnt 0
                        wrapper.width pixels
                angular.element(window).on 'resize', debounced

            # Add the template for this input if we haven't already done it
            $templateCache.put "mfValidate#{uid}", """
                <span
                    ng-repeat="error in $validation['#{name}'].$errors"
                    ng-bind='error'
                ></span>
            """
            wrapper.attr 'uib-tooltip-template', "'mfValidate#{uid}'"
            placementAttr = input.attr('mf-validate-tooltip-placement')
            wrapper.attr 'tooltip-placement', placementAttr or @tooltipPlacement
            # Focus can't work right now because of the wrapper
            wrapper.attr 'tooltip-trigger', 'focus mouseenter'

            wrapper.attr 'tooltip-enable', """
                $validation['#{name}'].$dirty &&
                $validation['#{name}'].$invalid
            """

            wrapper.insertBefore(inputWithAddons)

            $compile(wrapper)(inputScope)
            wrapper.append(inputWithAddons)

            # Don't add a watch for groups because they don't have an actual scope property to watch
            return if $scope.$validation[name].$isGroup

            ngModel = ngModel or input.attr('mf-validate-model') or input.attr('ng-model')

            return if input.attr('dont-watch')?
            inputScope.$watchCollection ngModel, (newValue, oldValue) =>
                # NaN !== NaN, so if both values are NaN, consider them equal
                # (val !== val is a simple way to check if val is actually NaN)
                if newValue isnt oldValue and not (newValue isnt newValue and oldValue isnt oldValue)
                    $scope.$validation[name].$dirty = true
                    @validate()

                    wrapper = topLevelElement.find("[mf-validate-uid=#{uid}]")
                    wrapper.parentsUntil(topLevelElement, '[mf-validate-group]').each (_, group) ->
                        groupName = angular.element(group).attr 'mf-validate-group'
                        $scope.$validation[groupName]?.$dirty = true
    ]

    link: ($scope, element, attrs, mfValidate) ->
        $scope.$validation = {}
        mfValidate.element = element
        $scope.$validationController = mfValidate

        validateOnLoad = $scope.$eval(element.attr('mf-validate-on-load'))

        mfValidate.tooltipPlacement = $scope.$eval(element.attr('mf-validate-tooltip-placement'))

        mfValidate.validate true if validateOnLoad
]
